import type React from "react";
import {Skeleton, Stack} from "@mui/material";
import FlowChartIcon from "~/components/icons/svg/FlowChartIcon.svg?react";
import AutoCategorizationIcon from "~/icons/svg/AutoCategorizationIcon.svg?react";
// import DollarCoinIcon from "~/icons/svg/DollarCoinIcon.svg?react";
// import WarningCircleIcon from "~/icons/svg/WarningCircleIcon.svg?react";
import {StatChip} from "~/components/StatChip/StatChip";
import {NO_VALUE} from "~/constants";
import {COLORS} from "~/style/colors-ts";
import type {m_taxonomy} from "~/services/classes/TaxonomyClasses";

/** Categories in the draft, deleted ones (and their branches) left out; the root is the taxonomy itself. */
const countCategories = (node: m_taxonomy.Tree): number =>
    node.children.filter(c => !c.removed).reduce((total, c) => total + 1 + countCategories(c), 0);

type TaxonomyBuilderKpisProps = {
    /** Undefined when the dataset has none: the values show as empty. */
    taxonomy?: m_taxonomy.FullSerializer;
    /** Skeleton pills while the taxonomy loads */
    isLoading: boolean;
};

/** KPI pills under the title. */
export const TaxonomyBuilderKpis: React.FC<TaxonomyBuilderKpisProps> = ({taxonomy, isLoading}) => isLoading ? (
    <Stack direction="row" flexWrap="wrap" useFlexGap gap="10px">
        <Skeleton variant="rounded" width={150} height={36}/>
        <Skeleton variant="rounded" width={150} height={36}/>
    </Stack>
) : (
    <Stack direction="row" flexWrap="wrap" useFlexGap gap="10px">
        <StatChip
            icon={{element: <FlowChartIcon/>, color: COLORS.info.main}}
            title="Taxonomy"
            value={taxonomy?.name ?? NO_VALUE}
        />
        <StatChip
            icon={{element: <AutoCategorizationIcon/>, color: COLORS.secondary.main}}
            title="Categories"
            value={taxonomy ? countCategories(taxonomy.diff_tree).toLocaleString() : NO_VALUE}
        />
        {/* Not in this version. */}
        {/* <StatChip
            icon={{element: <DollarCoinIcon/>, color: COLORS.success.main}}
            title="Spend mapped"
            value={NO_VALUE}
        />
        <StatChip
            icon={{element: <WarningCircleIcon/>, color: COLORS.warning.main}}
            title="Open findings"
            value={NO_VALUE}
        /> */}
    </Stack>
);
